// extracted by mini-css-extract-plugin
export default {"container":"nav-desktop_container__Ldj4p","nav":"nav-desktop_nav__CQ-Q4","logo":"nav-desktop_logo__KOhh+","link":"nav-desktop_link__AFCsZ"};